import { type RefObject, useEffect, useRef } from "react";

export interface UseClickAwayListenerParams {
  handler: () => void;
}

export const useClickAwayListener = <T extends HTMLElement>({
  handler,
}: UseClickAwayListenerParams): RefObject<T> => {
  const ref = useRef<T>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        event.target &&
        ref.current &&
        !ref.current.contains(event.target as Node)
      ) {
        handler();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handler]);

  return ref;
};
